import { create } from "zustand";
import { EducationForm, EducationPayload } from "../types/education";

type EducationState = {
  loading: boolean;
  updateEducations: (data: EducationForm[]) => Promise<boolean>;
};

const getAccessToken = (): string | null => {
    if (typeof window === "undefined") return null;

    try {
        const raw = localStorage.getItem("auth-storage");
        if (!raw) return null;

        const parsed = JSON.parse(raw);
        return parsed?.state?.accessToken || null;
    } catch (e) {
        console.error("❌ Failed to parse auth token:", e);
        return null;
    }
};

export const useEducationStore = create<EducationState>((set) => ({
  loading: false,

  updateEducations: async (data) => {
    try {
      set({ loading: true });

      const token = getAccessToken();

      if (!token) {
        throw new Error("No access token found");
      }


      const payload = {
        educations: data.map((e) => ({
          school_name: e.univTitle,
          degree_id: Number(e.univDegree),
          major: e.univMajor,
          start_date: `${e.startDate}-31`,
          end_date: e.current ? null : `${e.endDate}-31`,
          is_currently_study: e.current,
        })),
      };

      const res = await fetch(
        "https://admin-talentlink.digiline.id/api/candidate/education",
        {
          method: "POST",

          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
          body: JSON.stringify(payload),
        }
      );

      if (!res.ok) throw new Error("Update education failed");

      return true;
    } catch (err) {
      console.error(err);
      return false;
    } finally {
      set({ loading: false });
    }
  },
}));
